import { ReactNode, useState } from 'react';

import Button from '../../common/ui-kit/Button';

type button = {
  onClick: () => void;
  text: string;
};

const RevealRow = <T extends { [key: string]: any }>({
  object,
  className,
  visibleFields,
  openRowFields,
  button,
  keysToTitles,
  keysToRender,
}: {
  object: T;
  className?: string;
  visibleFields: (keyof T)[];
  openRowFields: (keyof T)[];
  onClick?: () => void;
  button?: button;
  keysToTitles: Partial<Record<keyof T, string>>;
  keysToRender?: Partial<Record<keyof T, (value: any, object: T) => ReactNode>>;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>();
  const handleOpen = () => {
    if (isOpen) {
      setIsOpen(false);
    } else setIsOpen(true);
  };
  return !isOpen ? (
    <div className="reveal-row-element" onClick={handleOpen}>
      <div className="reveal-row-element__closed">
        {Object.entries(object).map(([key, value]) => {
          const render = keysToRender?.[key];
          if (visibleFields.includes(key)) {
            return (
              <div>
                <b>{keysToTitles[key] ?? key}</b>:
                {render ? ` ${render(value, object)}` : ` ${value}`}
              </div>
            );
          }
          return;
        })}
      </div>
      <div className="reveal-row-element__right">
        {button && (
          <Button
            onClick={e => {
              e.stopPropagation();
              button.onClick();
            }}
          >
            {button.text}
          </Button>
        )}
      </div>
    </div>
  ) : (
    <div className="reveal-row-element" onClick={handleOpen}>
      <div className="reveal-row-element__opened">
        {Object.entries(object).map(([key, value]) => {
          const render = keysToRender?.[key];
          if (openRowFields.includes(key)) {
            return (
              <div>
                <b>{keysToTitles[key] ?? key}</b>:
                {render ? ` ${render(value, object)}` : ` ${value}`}
              </div>
            );
          }
          return;
        })}
      </div>
      <div className="reveal-row-element__right">
        {button && (
          <Button
            onClick={e => {
              e.stopPropagation();
              button.onClick();
            }}
          >
            {button.text}
          </Button>
        )}
      </div>
    </div>
  );
};

export default RevealRow;
